export default __webpack_public_path__ + "static/media/493.f8ec1156.png";